module.exports = __webpack_public_path__ + "img/apex.11c3818c.png";